'use client';

import classNames from 'classnames';
import { Hero } from '@sapientpro/sapientpro-data-models';
import { useSetAtom } from 'jotai';
import styles from './HeroSection.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Button, { ButtonVariants } from '../../../components/Button';
import ImagesBlock from './ImagesBlock';
import Img from '../../../components/Img';
import contactModalTriggerButton from '../../../store/contactForm';

const CTAButtonStyle = {
  primary: ButtonVariants.PRIMARY,
  transparent: ButtonVariants.OUTLINED,
};

const HeroSection = ({ data, altView }: { data: Hero; altView?: boolean }) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const showContactModal = () => setContactsModalTrigger('home hero section');

  return (
    <section className={classNames(styles.heroSection, {
      [styles.altView]: altView,
    })}
    >
      <div className={classNames(styles.heroSectionContent, 'container', 'home-page')}>
        <div className={styles.descriptionBlock}>
          <div className={styles.text}>
            <h1 className={styles.title}><AnimatedTitle title={data.title} /></h1>
            <p className={classNames(styles.description, 'bodyLarge')}>{data.subtitle}</p>
          </div>
          <div className={styles.altImages}>
            <Img
              src='https://sapientpro.fra1.digitaloceanspaces.com/ad048be77dab0f21a38bc63c42d38795.png'
              width={80}
              height={80}
              className={styles.heroAltImage}
              alt='decoration image'
            />
            <Img
              src='https://sapientpro.fra1.digitaloceanspaces.com/ad048be77dab0f21a38bc63c42d38795.png'
              width={80}
              height={80}
              className={styles.heroAltImage}
              alt='decoration image'
            />
            <Img
              src='https://sapientpro.fra1.digitaloceanspaces.com/ad048be77dab0f21a38bc63c42d38795.png'
              width={80}
              height={80}
              className={styles.heroAltImage}
              alt='decoration image'
            />
            <Img
              src='https://sapientpro.fra1.digitaloceanspaces.com/ad048be77dab0f21a38bc63c42d38795.png'
              width={80}
              height={80}
              className={styles.heroAltImage}
              alt='decoration image'
            />
          </div>
          <div className={styles.buttons}>
            {data.ctaButtons.map(ctaButton => {
              const isLink = ctaButton.type === 'link';

              const action = isLink ? { link: ctaButton.link as string } : {
                onClick: showContactModal,
              };

              return (
                <Button
                  key={ctaButton.id}
                  variant={CTAButtonStyle[ctaButton.style]}
                  icon={(
                    <svg>
                      <use
                        href='media/icon-nest.svg#iconNest'
                        xlinkHref='media/icon-nest.svg#iconNest'
                      />
                    </svg>
                )}
                  className={styles.heroButton}
                  {...action}
                >
                  {ctaButton.title}
                </Button>
              );
            })}
          </div>
        </div>
        <ImagesBlock items={data.sellingPoints} />
      </div>
      <svg className={styles.heroDecoration}>
        <use
          href='media/Home/Hero/hero_ellipse.svg#homeHeroEllipseSVG'
          xlinkHref='media/Home/Hero/hero_ellipse.svg#homeHeroEllipseSVG'
        />
      </svg>
    </section>
  );
};

export default HeroSection;
